<app-supplier-overview [user]="user" *ngIf="user"></app-supplier-overview>
